import { ColDef } from 'ag-grid-community'
import { getSearchReport } from 'api/reports'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import TableToolbar from 'components/table/TableToolbar'
import { useExportCSV } from 'hooks/useExportCSV'
import { useGridControl } from 'hooks/useGridControl'
import React, { useCallback, useMemo } from 'react'
import { BaseTableRequest, FilterModel } from 'types'
import { useGetDataSource } from 'utils'

export function ReportsSearches() {
  const columns: ColDef[] = useMemo(() => {
    return [
      { headerName: 'Term or Phrase', field: 'text' },
      { headerName: 'Type', field: 'type' },
      { headerName: 'Number of Searches', field: 'countOfSearches' },
      { headerName: 'Found Content', field: 'countOfResults' },
    ]
  }, [])

  const getRequest = useCallback((req: BaseTableRequest) => {
    const filter: FilterModel = {
      ...(req.filter || {}),
    }

    return getSearchReport({ ...req, filter })
  }, [])

  const getDataSource = useGetDataSource(getRequest)
  const { onGridReady, gridApi, columnApi } = useGridControl(getDataSource)

  const { csvLoading, onExportCSV } = useExportCSV(
    getRequest,
    gridApi,
    columnApi,
    columns.map((col) => {
      return { label: col.headerName || '', value: col.field || '' }
    }),
    'Searches Report.csv',
  )

  return (
    <>
      <TableToolbar exportCSVEnable onExportCSV={onExportCSV} csvLoading={csvLoading} />
      <InfinityAgGrid pagination columnDefs={columns} onGridReady={onGridReady} />
    </>
  )
}
